/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  SaveTransactionReversalReturn,
  TransactionReversalMadeResult,
  TransactionReversalResult,
  TransactionReversalReturn,
} from "src/@types/transaction-reversal";
import { apiSlice } from "./http";
import { Tags } from "@/enum/tags";

export const transactionReversalApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTransactionReversal: builder.query<TransactionReversalResult[], any>({
      query: ({ filters }: any) => {
        const params = new URLSearchParams({
          ...(filters.storeId !== undefined && {
            storeId: filters.storeId,
          }),
          ...(filters.operationType !== undefined && {
            operationType: filters.operationType,
          }),
          ...(filters.paymentType !== undefined && {
            paymentType: filters.paymentType,
          }),
          ...(filters.date !== undefined && {
            date: filters.date,
          }),
          ...(filters.cardNumber !== undefined && {
            cardNumber: filters.cardNumber,
          }),
          ...(filters.authorizationNsu !== undefined && {
            authorizationNsu: filters.authorizationNsu,
          }),
          ...(filters.networkNsu !== undefined && {
            networkNsu: filters.networkNsu,
          }),
          ...(filters.operationNumber !== undefined && {
            operationNumber: filters.operationNumber,
          }),
          ...(filters.couponNumber !== undefined && {
            couponNumber: filters.couponNumber,
          }),
          ...(filters.salesControlNumber !== undefined && {
            salesControlNumber: filters.salesControlNumber,
          }),
          ...(filters.initialValue !== undefined && {
            initialValue: filters.initialValue,
          }),
          ...(filters.finalValue !== undefined && {
            finalValue: filters.finalValue,
          }),
          ...(filters.isOnly1InSequence !== undefined && {
            isOnly1InSequence: filters.isOnly1InSequence,
          }),
          page: filters?.page ?? 1,
          perPage: filters?.perPage ?? 10,
        });
        return {
          url: `/transaction-reversal?${params.toString()}`,
          method: "GET",
          maxRetries: 0,
        };
      },
      providesTags: [Tags.TRANSACTION_REVERSAL],
    }),
    getTransactionDetails: builder.query<TransactionReversalResult[], any>({
      query: ({ infoParams }: any) => {
        const params = new URLSearchParams({
          ...(infoParams.storeId !== undefined && {
            storeId: infoParams.storeId,
          }),
          ...(infoParams.operationType !== undefined && {
            operationType: infoParams.operationType,
          }),
          ...(infoParams.paymentType !== undefined && {
            paymentType: infoParams.paymentType,
          }),
          ...(infoParams.date !== undefined && {
            date: infoParams.date,
          }),
          ...(infoParams.cardNumber !== undefined && {
            cardNumber: infoParams.cardNumber,
          }),
          ...(infoParams.authorizationNsu !== undefined && {
            authorizationNsu: infoParams.authorizationNsu,
          }),
          ...(infoParams.networkNsu !== undefined && {
            networkNsu: infoParams.networkNsu,
          }),
          ...(infoParams.operationNumber !== undefined && {
            operationNumber: infoParams.operationNumber,
          }),
          ...(infoParams.couponNumber !== undefined && {
            couponNumber: infoParams.couponNumber,
          }),
          ...(infoParams.salesControlNumber !== undefined && {
            salesControlNumber: infoParams.salesControlNumber,
          }),
          ...(infoParams.initialValue !== undefined && {
            initialValue: infoParams.initialValue,
          }),
          ...(infoParams.finalValue !== undefined && {
            finalValue: infoParams.finalValue,
          }),
          ...(infoParams.isOnly1InSequence !== undefined && {
            isOnly1InSequence: infoParams.isOnly1InSequence,
          }),
          page: '1',
          perPage: '100',
        });
        return {
          url: `/transaction-reversal?${params.toString()}`,
          method: "GET",
          maxRetries: 0,
        };
      },
      providesTags: [Tags.TRANSACTION_REVERSAL],
    }),
    updateTransactionReversal: builder.mutation<
      TransactionReversalReturn,
      { data: any }
    >({
      query: ({ data }) => ({
        url: `/transaction-reversal/update-tippes`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: [Tags.TRANSACTION_REVERSAL],
    }),
    saveTransactionReversal: builder.mutation<
      SaveTransactionReversalReturn,
      { data: any }
    >({
      query: ({ data }) => ({
        url: `/transaction-reversal/save-transaction-reversal`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: [Tags.TRANSACTION_REVERSAL],
    }),
    getTransactionReversalMade: builder.query<TransactionReversalMadeResult[], any>({
      query: ({ filters }: any) => {
        const params = new URLSearchParams({
          ...(filters.storeId !== undefined && {
            storeId: filters.storeId,
          }),
          ...(filters.dateStart !== undefined && {
            dateStart: filters.dateStart,
          }),
          ...(filters.dateEnd !== undefined && {
            dateEnd: filters.dateEnd,
          }),
          ...(filters.authorizationNsu !== undefined && {
            authorizationNsu: filters.authorizationNsu,
          }),
          ...(filters.paymentValue !== undefined && {
            paymentValue: filters.paymentValue,
          }),
          ...(filters.user !== undefined && {
            user: filters.user,
          }),
          ...(filters.operationType !== undefined && {
            operationType: filters.operationType,
          }),
          ...(filters.paymentType !== undefined && {
            paymentType: filters.paymentType,
          }),
          page: filters?.page ?? 1,
          perPage: filters?.perPage ?? 10,
        });
        return {
          url: `/transaction-reversal/transactions-reversal-made?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.TRANSACTION_REVERSAL],
    }),

    exportTransactionReversalMadeToExcel: builder.mutation<Blob, any>({
      query: ({ filters }: any) => {
        const params = new URLSearchParams({
          ...(filters.storeId !== undefined && {
            storeId: filters.storeId,
          }),
          ...(filters.dateStart !== undefined && {
            dateStart: filters.dateStart,
          }),
          ...(filters.dateEnd !== undefined && {
            dateEnd: filters.dateEnd,
          }),
          ...(filters.authorizationNsu !== undefined && {
            authorizationNsu: filters.authorizationNsu,
          }),
          ...(filters.paymentValue !== undefined && {
            paymentValue: filters.paymentValue,
          }),
          ...(filters.user !== undefined && {
            user: filters.user,
          }),
          ...(filters.operationType !== undefined && {
            operationType: filters.operationType,
          }),
          ...(filters.paymentType !== undefined && {
            paymentType: filters.paymentType,
          }),
          page: '1',
          perPage: '99999',
        });

        return {
          url: `/transaction-reversal/transactions-reversal-made/export-excel?${params.toString()}`,
          method: "GET",
          responseHandler: async (response: Response) => {
            return await response.blob();
          },
          cache: 'no-cache',
        };
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetTransactionReversalQuery,
  useGetTransactionDetailsQuery,
  useUpdateTransactionReversalMutation,
  useSaveTransactionReversalMutation,
  useGetTransactionReversalMadeQuery,
  useExportTransactionReversalMadeToExcelMutation,
} = transactionReversalApi;

export const {
  endpoints: {
    getTransactionReversal: { select: selectGetTransactionReversal },
    updateTransactionReversal: { select: updateTransactionReversal },
    saveTransactionReversal: { select: saveTransactionReversal },
    getTransactionReversalMade: { select: selectGetTransactionReversalMade },
  },
} = transactionReversalApi;
